// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"571":"settings","921":"video","969":"success"}[chunkId] + "." + {"571":"daf02bdc","921":"e51dfa08","969":"f2dd1b41"}[chunkId] + ".css";
};